import apiClient from "services/apiClient";

async function importData(id: number) {
    const url = `/admin/imports/${id}/import`;
    const res = await apiClient.post(url);
    return res.data;
}

export default importData;
